<template>
  <div class="container-nzidoo">
    <page-title :title="$t('menu.list.categories')" />

    <!-- Toolbar -->
    <div class="admin-toolbar">
      <div class="admin-search-box">
        <i class="mdi mdi-magnify admin-search-icon"></i>

        <input type="text" v-model="searchTerm" :placeholder="$t('sentence.searchByName')" class="admin-search-input">

        <!-- Clear icon -->
        <i v-if="searchTerm" class="mdi mdi-close-circle admin-clear-icon" @click="clearSearch"
          :title="$t('sentence.clear')"></i>
      </div>

      <button class="btn btn-primary" @click="addCategory">
        <i class="mdi mdi-plus"></i>
        <div class="d-none d-md-block">
          {{ $t("action.add") }} {{ $t("main.category") }}
        </div>
      </button>
    </div>
    <LoadingSpinner v-if="loader" />
    <!-- Categories Grid -->
    <div v-else class="admin-grid">
      <div v-for="cat in filteredParentCategories" :key="cat.id" class="admin-card">
        <div class="admin-card-header">
          <span class="chatbot-card-id">{{ $t('main.category') }}: {{ cat.name }}</span>
          <div class="admin-card-actions">
            <button class="btn btn-icon-action btn-primary" @click="getCategoryById(cat.id)" :title="$t('action.edit')">
              <i class="mdi mdi-pencil"></i>
            </button>
            <button class="btn btn-icon-action btn-success" @click="addSubCategoryById(cat)"
              :title="$t('action.add') + ' ' + $t('main.subcategory')">
              <i class="mdi mdi-plus"></i>
            </button>
            <button class="btn btn-icon-action btn-danger" @click="removeCategory(cat.id)" :title="$t('action.delete')">
              <i class="mdi mdi-delete"></i>
            </button>
          </div>
        </div>
        <div class="admin-card-body">
          <div class="admin-card-section" v-if="cat.picture">
            <img :src="cat.picture ? storageUrl + cat.picture : img_not_found" alt="" class="category-image">
          </div>
          <div class="admin-card-section" v-if="subCategories(cat.id).length > 0">
            <label class="admin-card-label">{{ $t('main.subcategories') }}</label>
            <div class="subcategories-list">
              <div v-for="sub in subCategories(cat.id)" :key="sub.id" class="subcategory-item">
                <span class="card-name">{{ sub.name }}</span>
                <div class="subcategory-actions">
                  <button class="btn btn-icon-action btn-sm btn-warning" @click="getCategoryById(sub.id)"
                    :title="$t('action.edit')">
                    <i class="mdi mdi-pencil"></i>
                  </button>
                  <button class="btn btn-icon-action btn-sm btn-danger" @click="removeCategory(sub.id)"
                    :title="$t('action.delete')">
                    <i class="mdi mdi-delete"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div v-if="filteredParentCategories.length === 0" class="admin-empty-state">
        <svg class="admin-empty-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
        </svg>
        <p class="admin-empty-text">{{ $t('sentence.noResults') }}</p>
      </div>
    </div>

    <!-- Drawer Backdrop -->
    <transition name="drawer-backdrop">
      <div v-if="showModal" class="admin-drawer-backdrop" @click="closeModal"></div>
    </transition>

    <!-- Drawer -->
    <transition name="drawer">
      <div v-if="showModal" class="admin-drawer-container">
        <div class="admin-drawer-header">
          <h3 class="admin-drawer-title">
            {{ isEditing ? $t('action.update') : $t('action.add') }} {{ $t('main.category') }}
          </h3>
          <button class="btn btn-close" @click="closeModal">
            <i class="mdi mdi-close"></i>
          </button>
        </div>

        <div class="admin-drawer-body">
          <div class="admin-form-group" v-if="parent_category != ''">
            <label class="admin-form-label">{{ $t('main.category') }} Parent</label>
            <div class="parent-category-badge">{{ parent_category }}</div>
          </div>

          <div class="admin-form-group">
            <label class="admin-form-label">
              {{ parent_category != '' ? $t('main.subcategory') : $t('main.category') }} {{ $t('attr.name') }}
            </label>
            <input type="text" v-model="category.name" class="admin-form-input" :placeholder="$t('attr.name')">
            <input type="text" hidden="hidden" v-model="category.parent_id">
          </div>

          <div class="admin-form-group">
            <label class="admin-form-label">{{ $t('main.category') }} {{ $t('attr.pictures') }}</label>
            <div class="custom-file mb-1">
              <input type="file" class="custom-file-input" id="picture" name="picture" ref="picture"
                v-on:change="onPictureChange" />
              <label class="custom-file-label" for="picture">{{ $t('action.chooseFile') }}...</label>
            </div>
          </div>

          <div class="admin-form-group">
            <label class="admin-form-label">Category Attributes</label>
            <i class="mdi mdi-plus-circle add-attribute-btn" @click="add(0)" v-show="attributes.length == 0">
              {{ $t('action.addFields') }}
            </i>
          </div>

          <div class="attribute-item" v-for="(attribute, index) in attributes" :key="index">
            <input type="text" class="admin-form-input" v-model="attribute.title" :placeholder="$t('attr.name')">
            <vue-tags-input style="max-width: 100% !important;margin-top: 5%;" v-model="tag" :tags="attribute.default_value == null ||
                attribute.default_value == ''
                ? []
                : attribute.default_value
              " @tags-changed="
                          (newTags) => (attribute.default_value = newTags)
                        " />
            <div class="attribute-actions">
              <i class="mdi mdi-minus-circle" @click="remove(index, attribute.id)"
                v-show="index || attributes.length > 1">
                {{ $t('action.delete') }}
              </i>
              <i class="mdi mdi-plus-circle" @click="add(index)" v-show="index == attributes.length - 1">
                {{ $t('action.addFields') }}
              </i>
            </div>
          </div>
        </div>

        <div class="admin-drawer-footer">
          <button class="btn btn-secondary" @click="closeModal">
            {{ $t('action.cancel') }}
          </button>
          <button class="btn btn-primary" @click="submitCategory">
            {{ isEditing ? $t('action.update') : $t('action.create') }}
          </button>
        </div>
      </div>
    </transition>

    <notifications style="top:5%;" width="35%" group="error" position="top center" />
    <notifications style="top:5%;" width="35%" group="success" position="top center" />
  </div>
</template>

<script>
import PageTitle from '@/components/templates/PageTitle.vue';
import VueTagsInput from "@johmun/vue-tags-input";
import AlertService from '@/services/alertService';
import LoadingSpinner from "@/components/templates/LoadingSpinner.vue";
import config from "@/config";
import img_not_found from "@/assets/img/img_not_found.jpg";


export default {
  components: {
    PageTitle,
    LoadingSpinner,
    VueTagsInput
  },
  name: "CategoriesAdmin",

  data() {
    return {
      categories: [],
      category: {
        parent_id: 0,
      },
      parent_category: "",
      showModal: false,
      isEditing: false,
      searchTerm: "",
      attributes: [],
      toDeleteAttributes: [],
      tag: "",
      storageUrl: config.storageUrl,
      img_not_found: img_not_found,
      loader: false,
    };
  },

  computed: {
    parentCategories() {
      return this.categories.filter((i) => i.parent_id==0);
    },
    filteredParentCategories() {
      if (!this.searchTerm) return this.parentCategories;

      const term=this.searchTerm.toLowerCase();
      return this.parentCategories.filter(cat =>
        cat.name.toLowerCase().includes(term)
      );
    }
  },

  mounted() {
    this.getCategories();
  },

  methods: {
    clearSearch() {
      this.searchTerm="";
    },
    async getCategories() {
      try {
        this.loader=true;
        const response=await this.$axios.get("category/list");
        this.categories=response.data;
        // this.$store.commit("SET_CATEGORIES", { categories: this.categories });
        this.$store.commit("setCategories", { categories: this.categories });
        this.category={
          parent_id: 0,
        };
        this.loader=false;
      } catch (err) {
        console.error("Error loading categories:", err);
        this.$notify({
          group: "error",
          title: this.$t('sentence.errorLoading')||"Error loading categories",
          type: "error",
        });
      }
    },

    addCategory() {
      this.isEditing=false;
      this.showModal=true;
      this.parent_category="";
      this.category={
        parent_id: 0,
      };
      this.attributes=[];
    },

    addSubCategoryById(category) {
      this.isEditing=false;
      this.showModal=true;
      this.parent_category=category.name;
      this.category={
        parent_id: category.id,
      };
      this.attributes=[];
    },

    async getCategoryById(categoryId) {
      this.isEditing=true;
      try {
        const response=await this.$axios.get("category/list/"+categoryId);
        this.category=response.data[0];

        if (this.category.parent_id==0) {
          this.parent_category="";
        } else {
          this.parent_category=this.getCategory(this.category.parent_id)[0].name;
        }
        this.attributes=this.category.attributes||[];
        this.showModal=true;
      } catch (err) {
        console.error("Error loading category:", err);
        this.$notify({
          group: "error",
          title: this.$t('sentence.errorLoading')||"Error loading category",
          type: "error",
        });
      }
    },

    closeModal() {
      this.showModal=false;
      this.category={
        parent_id: 0,
      };
      this.attributes=[];
      this.toDeleteAttributes=[];
      this.parent_category="";
    },

    async submitCategory() {
      try {
        this.loader=true;
        var category=this.category;
        var url;
        var formData=new FormData();

        if (category.id===undefined) {
          url="admin/category/create";
        } else {
          url="admin/category/update/"+category.id;
        }

        formData.append("name", category.name);
        formData.append("parent_id", category.parent_id);

        if (this.attributes.length>0) {
          formData.append("attributes", JSON.stringify(this.attributes));
        }

        formData.append("toDelete", this.toDeleteAttributes);

        if (category.picture!==undefined) {
          formData.append("picture", category.picture);
        }

        const response=await this.$axios.post(url, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        this.$notify({
          group: "success",
          title: response.data.message||this.$t('sentence.success'),
          type: "success",
        });

        this.closeModal();
        this.getCategories();
      } catch (err) {
        console.error("Error saving category:", err);
        this.$notify({
          group: "error",
          title: err.response?.data?.message||this.$t('sentence.errorSaving'),
          type: "error",
        });
      } finally {
        this.loader=false;
      }
    },

    async removeCategory(categoryId) {
      const confirmed=await AlertService.confirm({
        title: this.$t('sentence.confirmDelete')||"Are you sure?",
        confirmButtonText: this.$t('action.delete')||"Delete",
        cancelButtonText: this.$t('action.cancel')||"Cancel",
        icon: "warning"
      });

      if (!confirmed) return;

      try {
        const response=await this.$axios.post("admin/category/delete/"+categoryId);
        this.$notify({
          group: "success",
          title: response.data.message||this.$t('sentence.deleteSuccess'),
          type: "success",
        });
        this.getCategories();
      } catch (err) {
        console.error("Error deleting category:", err);
        this.$notify({
          group: "error",
          title: err.response?.data?.message||this.$t('sentence.errorDeleting'),
          type: "error",
        });
      }
    },

    subCategories(categoryId) {
      return this.categories.filter(
        (i) => i.parent_id!=0&&categoryId==i.parent_id
      );
    },

    getCategory(id) {
      return this.categories.filter((i) => i.id==id);
    },

    add() {
      this.attributes.push({
        id: "",
        title: "",
      });
    },

    remove(index, id) {
      this.toDeleteAttributes.push(id);
      this.attributes.splice(index, 1);
    },

    onPictureChange() {
      this.category.picture=this.$refs.picture.files[0];
    },
  }
};
</script>

<style scoped src="@/assets/css/shared-admin-styles.css"></style>
<style scoped>

/* Component-specific styles */
.chatbot-card-id {
  font-size: 13px;
  font-weight: 600;
  color: var(--gray-600);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.category-image {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 12px;
}

.subcategories-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.subcategory-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: var(--gray-50);
  border-radius: 6px;
  border: 1px solid var(--gray-200);
}

.subcategory-actions {
  display: flex;
  gap: 4px;
}

.btn-sm {
  padding: 4px 8px;
  font-size: 12px;
}

.parent-category-badge {
  display: inline-block;
  padding: 8px 16px;
  background: var(--blue-50);
  color: var(--blue-700);
  border-radius: 6px;
  font-weight: 500;
  border: 1px solid var(--blue-200);
}

.add-attribute-btn {
  cursor: pointer;
  color: var(--blue-600);
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.add-attribute-btn:hover {
  color: var(--blue-700);
}

.attribute-item {
  padding: 12px;
  background: var(--gray-50);
  border-radius: 8px;
  margin-bottom: 12px;
  border: 1px solid var(--gray-200);
}

.attribute-actions {
  display: flex;
  gap: 16px;
  margin-top: 8px;
}

.attribute-actions i {
  cursor: pointer;
  color: var(--gray-600);
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.attribute-actions i:hover {
  color: var(--blue-600);
}

.mdi-minus-circle:hover {
  color: var(--red-600) !important;
}

.mdi-plus-circle:hover {
  color: var(--green-600) !important;
}
</style>